import React from 'react';
import { IIconProps } from '../interfaces';
const YouTubeInfoIcon = (props: IIconProps) => {

  const width=props.width? parseInt(props.width) : 25;
  const height= props.height == null ? (width - width/5) : props.height;
  return (
      <svg width={width} height={height} viewBox="0 0 25 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.025 1C2.805 1 1 2.883 1 5.2v9.6C1 17.117 2.805 19 5.025 19h14.95C22.195 19 24 17.117 24 14.8V5.2C24 2.883 22.195 1 19.975 1H5.025zm0 1.2h14.95c1.603 0 2.875 1.328 2.875 3v9.6c0 1.672-1.272 3-2.875 3H5.025c-1.603 0-2.875-1.328-2.875-3V5.2c0-1.672 1.272-3 2.875-3zm4.852 3.3a.59.59 0 0 0-.54.6v7.8a.591.591 0 0 0 .513.6c.114.013.23-.01.332-.066l6.9-3.9a.604.604 0 0 0 .304-.53.603.603 0 0 0-.304-.529l-6.9-3.9a.55.55 0 0 0-.305-.075zm.61 1.612L15.609 10l-5.12 2.897V7.112z" fill={props.color} stroke={props.color} strokeWidth=".55" fillRule="evenodd"/>
      </svg>

  )
};

export default YouTubeInfoIcon;